export default "__VITE_ASSET__DEuGALAr__"